// extracted by mini-css-extract-plugin
export default {"titleBox":"styles_titleBox__TCsFK","titleBoxtext":"styles_titleBoxtext__UrQGG","titleBoxtitle":"styles_titleBoxtitle__8Zr-T"};